export default __webpack_public_path__ + "static/media/Resume-converted-compressed.e768eb8e.pdf";